// https://itnext.io/how-to-use-a-single-instance-of-socket-io-in-your-react-app-6a4465dcb398
import { createContext } from "react";
import { Socket, io } from "socket.io-client";
import { SessionStatus, Stored, StudentOpinion } from "../types";

export type TeacherUpdateMessage = {
  type: "student-answered";
  studentOpinion: Stored<StudentOpinion>;
};

interface ServerToClientEvents {
  participants: (participants: number) => void;
  updateStatus: (status: SessionStatus) => void;
  updateCurrentIndex: (index: number) => void;
  showResults: (showResults: boolean) => void;
  teacherUpdate: (message: TeacherUpdateMessage) => void;
}

interface ClientToServerEvents {
  subscribe: (code: string) => void;
}

export type SocketType = Socket<ServerToClientEvents, ClientToServerEvents>;

let socketURL: string;
if (import.meta.env.VITE_SOCKET_URL !== undefined) {
  socketURL = import.meta.env.VITE_SOCKET_URL;
} else if (import.meta.env.PROD) {
  socketURL = "/";
} else {
  socketURL = "http://localhost:4000";
}

export const socket = io(socketURL, { transports: ["websocket"] });

const SocketContext = createContext<SocketType>(socket);

export default SocketContext;
